import { isDesktop } from 'react-device-detect';
import BonusGameController from '../../controllers/bonus/BonusGameController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { BonusGameGridView } from './BonusGameGridView';
import { BonusGameItems } from './BonusItems';

let scale = isDesktop ? 1 : 0.5;
export const BonusGameView = {
	name: COMPONENTS.BONUS_GAME,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: BonusGameController,
			name: 'BonusGameController',
			config: {
				item: 'bonus_game_wrapper',
				val: 'bonus_game_wrapper'
			}
		},
		{
			Controller: MainGridController,
			name: 'BonusGameViewGrid',
			config: BonusGameGridView
		}
	],
	components: [
		{
			name: 'fg_holder',
			type: 'Sprite',
			components: [
				isDesktop
					? {
							name: 'bonus_fg',
							type: 'AnimatedSprite',
							position: {
								x: 0,
								y: 190
							},
							animation: {
								pattern: 'mciddle_000$.png',
								start: 0,
								end: 51,
								speed: 0.5,
								precision: 2,
								loop: true,
								scale: {
									x: isDesktop ? 1 : 2,
									y: isDesktop ? 1 : 2
								}
							}
						}
					: {
							name: 'bonus_fg',
							type: 'Sprite',
							position: {
								x: 0,
								y: 190
							},
							scale: {
								x: isDesktop ? 1 : 2,
								y: isDesktop ? 1 : 2
							},
							img: 'main_character_m'
						},
				isDesktop && {
					name: 'bonus_fg_wow',
					type: 'AnimatedSprite',
					position: {
						x: 0,
						y: 162
					},
					animation: {
						pattern: 'wow_000$.png',
						start: 0,
						end: 51,
						speed: 0.5,
						precision: 2,
						loop: false,
						scale: {
							x: isDesktop ? 1 : 1,
							y: isDesktop ? 1 : 1
						}
					}
				}
			]
		},
		{
			name: 'btn_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bonus_btn',
					type: 'StopButton',
					position: { x: 0, y: 0 },
					bg: 'spin_btn',
					bg_icon: 'stop_icon',
					animation: {
						pattern: 'stop_button_000$.png',
						start: 0,
						end: 23,
						speed: 0.5,
						loop: true,
						scale: scale
					}
				}
			]
		},
		{
			name: 'win_bg_wrapper',
			type: 'Sprite',
			components: [
				{
					name: 'win_bg',
					type: 'Sprite',
					img: 'error_content_bg',
					position: { x: 0, y: 0 }
				},
				{
					name: 'win_text',
					type: 'Text',
					text: 'BONUS_WIN_TEXT',
					position: { x: 373 / 2, y: 20 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'win_value',
					type: 'Text',
					text: 'BONUS_WIN_VALUE',
					position: { x: 373 / 2, y: 38 },
					anchor: { x: 0.5, y: 0 }
				}
			]
		},
		{
			name: 'BonusItems',
			type: 'VisualComponent',
			component: BonusGameItems
		}
	]
};
